/*
 * Copyright 2025 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package ui

/**
 * Shared tab types for cross-platform tab navigation
 * Maps to the same structure used in iOS and Android
 */
enum class AppTabType(
    val displayName: String,
    val tabIndex: Int,
) {
    TRANSACTIONS("Activity", 0),
    DASHBOARD("Dashboard", 1),
    PROJECTIONS("Analysis", 2),
    GOALS("Goals", 3),
    BUDGET_PLANNING("Budget", 4),
    SETTINGS("Settings", 5),
    ;

    companion object {
        fun fromIndex(index: Int): AppTabType? = values().find { it.tabIndex == index }
    }
}
